export type AddressVerifyRequest = {
    Street: string;
    StreetNumber: string;
    PostalCode: string;
    City: string;
};

export class SuggestedAddress {
    public Street: string;
    public HouseNumber: string;
    public ZipCode: string;
    public City: string;
}

export class AddressVerifyResponse {
    public IsValid: boolean;
    public IsAdjusted: boolean;
    public SuggestedAddress: SuggestedAddress;

    DeserializeType(): void {
        // nothing to do here
    }
}